import {
  getActorLeaderStatus,
  subscribeActorLeaderStatus,
  type ActorLeaderStatus,
} from "@-/dev.improve.haniverse.database.actor";
import { useSyncExternalStore } from "react";

/**
 * This tab's standing in the web multi-tab leader election for the actor
 * database (plan §8): is THIS tab the one whose worker owns the OPFS file, or is
 * it proxying to another tab's?
 *
 * `null` on native (no election) and on web until the connection is open.
 *
 * Meant for a settings/debug indicator, NOT for a "reconnecting…" banner: a
 * handover lasts a few hundred ms and should present as ordinary loading state,
 * so a banner would only flicker. Its value is diagnostic — "which tab holds
 * leadership" is the first question when a user reports odd multi-tab
 * behaviour.
 *
 * Re-renders on leadership/connection transitions only; the snapshot's
 * `proxiedQueryCount` is a live getter that does not (see `ActorLeaderStatus`).
 */
export function useLeaderResourceStatus(): ActorLeaderStatus | null {
  return useSyncExternalStore(
    subscribeActorLeaderStatus,
    getActorLeaderStatus,
    // Server snapshot: SSR renders before any connection exists, and the client
    // hydrates against the same `null` before its own open resolves.
    () => null,
  );
}
